(function () {
  function lpFpFormatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return String(cents);

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var key = match[1];
    var value = '';

    switch (key) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    if (format.indexOf('with_comma_separator') !== -1) {
      return format.replace(placeholderRegex, value).replace(',00', '');
    }
    return format.replace(placeholderRegex, value).replace('.00', '');
  }

  function destroySwiper(el) {
    if (el && el.swiper) {
      el.swiper.destroy(true, true);
    }
  }

  function syncSellingPlanVisuals(wrap) {
    var options = wrap.querySelectorAll('.lp-Fp_PlanOption');
    var checked = wrap.querySelector('.lp-Fp_PlanInput:checked');
    options.forEach(function (opt) {
      opt.classList.toggle('is-selected', !!(checked && opt.contains(checked)));
    });
  }

  function initSellingPlans(root) {
    root.querySelectorAll('[data-lp-fp-selling-plans]').forEach(function (wrap) {
      var options = wrap.querySelectorAll('.lp-Fp_PlanOption');

      function syncVisual() {
        syncSellingPlanVisuals(wrap);
      }

      wrap.addEventListener('change', function (e) {
        if (e.target.classList.contains('lp-Fp_PlanInput')) syncVisual();
      });

      wrap.addEventListener(
        'click',
        function (e) {
          var opt = e.target.closest('.lp-Fp_PlanOption');
          if (!opt || !wrap.contains(opt)) return;
          var input = opt.querySelector('.lp-Fp_PlanInput');
          if (!input || input.disabled) return;
          if (!input.checked) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            wrap.querySelectorAll('.lp-Fp_PlanInput').forEach(function (inp) {
              inp.checked = inp === input;
            });
            syncVisual();
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            syncVisual();
          }
        },
        true
      );

      syncVisual();
    });
  }

  function resyncSellingPlansAfterRestore() {
    document.querySelectorAll('[data-lp-fp-selling-plans]').forEach(function (wrap) {
      var checked = wrap.querySelector('.lp-Fp_PlanInput:checked');
      if (!checked) {
        var subInp = wrap.querySelector('.lp-Fp_PlanOption[data-lp-fp-plan="subscription"] .lp-Fp_PlanInput');
        var oneInp = wrap.querySelector('.lp-Fp_PlanOption[data-lp-fp-plan="onetime"] .lp-Fp_PlanInput');
        var pick = subInp || oneInp || wrap.querySelector('.lp-Fp_PlanInput');
        if (pick) {
          wrap.querySelectorAll('.lp-Fp_PlanInput').forEach(function (inp) {
            inp.checked = inp === pick;
          });
          pick.checked = true;
        }
        checked = wrap.querySelector('.lp-Fp_PlanInput:checked');
      }
      syncSellingPlanVisuals(wrap);
      if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function checkoutHref() {
    var r = (window.routes && window.routes.rootUrl) || '/';
    if (r === '/') return '/checkout';
    return String(r).replace(/\/?$/, '') + '/checkout';
  }

  function clearCart() {
    var cartUrl = window.routes && window.routes.cartUrl;
    if (!cartUrl) return Promise.reject(new Error('Cart URL missing'));
    return fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return null;
        var updates = {};
        cart.items.forEach(function (item) {
          updates[item.key] = 0;
        });
        return fetch(cartUrl + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
          credentials: 'same-origin',
        }).then(function (res) {
          if (!res.ok) return res.json().then(function (j) {
            throw new Error((j && (j.description || j.message)) || 'Could not clear cart');
          });
          return null;
        });
      });
  }

  function addLineToCart(item) {
    return addItemsToCart([item]);
  }

  function addItemsToCart(items) {
    var addUrl = window.routes && window.routes.cartAddUrl;
    if (!addUrl) return Promise.reject(new Error('Cart add URL missing'));
    if (!items || items.length === 0) return Promise.resolve(null);
    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
    }).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) {
          throw new Error((body && (body.description || body.message)) || 'Could not add to cart');
        }
        return body;
      });
    });
  }

  function getGiftDiscountCodesRaw(root) {
    var el = root.querySelector('[data-lp-fp-gift-discount-codes]');
    if (!el) return '';
    try {
      var val = JSON.parse(el.textContent || '""');
      if (val == null) return '';
      return String(val);
    } catch (e) {
      return '';
    }
  }

  function normalizeDiscountCodesForCart(raw) {
    if (!raw || typeof raw !== 'string') return '';
    return raw
      .split(/[\n,;]+/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean)
      .join(',');
  }

  // Reads a response as JSON without throwing on an empty or non-JSON body.
  // /cart/update.js can answer 200 with no body at all, and a bare res.json()
  // then rejects with "Unexpected end of JSON input".
  function readJsonSafe(res) {
    return res.text().then(function (txt) {
      if (!txt) return null;
      try {
        return JSON.parse(txt);
      } catch (e) {
        return null;
      }
    });
  }

  // Applying a discount to the cart is best-effort and never rejects. Its
  // response is not proof of anything: only the cart can say whether the gifts
  // actually came out free, so callers must verify with giftLinesAreFree.
  function applyCartDiscountCodes(discountJoined) {
    if (!discountJoined) return Promise.resolve(null);
    var cartUrl = window.routes && window.routes.cartUrl;
    if (!cartUrl) return Promise.resolve(null);
    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discountJoined }),
      credentials: 'same-origin',
    })
      .then(readJsonSafe)
      .catch(function () {
        return null;
      });
  }

  function discountRouteUrl(code) {
    var r = (window.routes && window.routes.rootUrl) || '/';
    var base = r === '/' ? '' : String(r).replace(/\/?$/, '');
    return base + '/discount/' + encodeURIComponent(code);
  }

  // Fallback that lets Shopify apply the codes itself through its documented
  // /discount/<code> route, rather than the undocumented cart/update.js form.
  function applyDiscountsViaRoute(discountJoined) {
    var codes = String(discountJoined || '')
      .split(',')
      .map(function (c) {
        return c.trim();
      })
      .filter(Boolean);
    return codes
      .reduce(function (chain, code) {
        return chain.then(function () {
          return fetch(discountRouteUrl(code), { credentials: 'same-origin' }).catch(function () {
            return null;
          });
        });
      }, Promise.resolve(null))
      .then(function () {
        return null;
      });
  }

  // A gift that is not in the cart at all cannot be overcharged, so it passes.
  function cartGiftsAreFree(cart, giftVariantIds) {
    if (!cart || !cart.items) return false;
    return cart.items.every(function (item) {
      if (giftVariantIds.indexOf(item.variant_id) === -1) return true;
      return item.final_line_price === 0;
    });
  }

  // Source of truth: are the gift lines actually costing the shopper nothing?
  // /cart/update.js returns the updated cart on success, so pass that body in
  // as `knownCart` to answer without a second round trip. Only re-fetch when
  // the response was empty or unparseable, which is exactly the broken case.
  function giftLinesAreFree(giftVariantIds, knownCart) {
    var cartUrl = window.routes && window.routes.cartUrl;
    if (!cartUrl || !giftVariantIds || giftVariantIds.length === 0) return Promise.resolve(true);
    if (knownCart && knownCart.items) {
      return Promise.resolve(cartGiftsAreFree(knownCart, giftVariantIds));
    }
    return fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? readJsonSafe(res) : null;
      })
      .then(function (cart) {
        return cartGiftsAreFree(cart, giftVariantIds);
      })
      .catch(function () {
        return false;
      });
  }

  function readFunnelContext(root) {
    var ctx = {};
    var el = root.querySelector('[data-lp-fp-funnel]');
    if (el) {
      try {
        ctx = JSON.parse(el.textContent || '{}') || {};
      } catch (e) {
        ctx = {};
      }
    }
    if (!ctx.funnel) {
      var m = String(window.location.pathname || '').match(/\/pages\/([^/?#]+)/);
      ctx.funnel = m ? m[1] : '';
    }
    return ctx;
  }

  function buildFunnelAttributes(ctx, btn, mode, giftCount) {
    // Every key is always written. Shopify deletes an attribute set to an empty
    // string, so a full overwrite guarantees a cart cannot carry a stale value
    // from a lander the shopper visited earlier.
    return {
      funnel: String(ctx.funnel || ''),
      funnel_template: String(ctx.template || ''),
      funnel_plan: mode === 'subscription' ? 'flex' : 'onetime',
      funnel_tier: String(btn.getAttribute('data-variant-title') || ''),
      funnel_kit: String(btn.getAttribute('data-kit-count') || ''),
      funnel_variant_id: String(btn.getAttribute('data-variant-id') || ''),
      funnel_gifts: String(giftCount || 0),
    };
  }

  function applyCartAttributes(attrs) {
    if (!attrs || Object.keys(attrs).length === 0) return Promise.resolve(null);
    var cartUrl = window.routes && window.routes.cartUrl;
    if (!cartUrl) return Promise.resolve(null);
    return fetch(cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin',
    }).then(function (res) {
      return res.ok ? res.json() : null;
    });
  }

  function stampKlaviyo(attrs) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', attrs]);
      window._learnq.push(['track', 'Lander Checkout Started', attrs]);
    } catch (e) {
      /* analytics must never break checkout */
    }
  }

  function parseLpFpPurchaseConfig(root) {
    var config = {};
    var legacyEl = root.querySelector('[data-lp-fp-purchase-config]');
    var vEl = root.querySelector('[data-lp-fp-purchase-config-variants]');
    var cEl = root.querySelector('[data-lp-fp-purchase-config-cta]');
    try {
      if (legacyEl) {
        config = JSON.parse(legacyEl.textContent || '{}');
      } else {
        if (vEl) Object.assign(config, JSON.parse(vEl.textContent || '{}'));
        if (cEl) Object.assign(config, JSON.parse(cEl.textContent || '{}'));
      }
    } catch (e) {
      config = {};
    }

    return config;
  }

  function syncGiftOffers(root) {
    var wrap = root.querySelector('[data-lp-fp-gift-offers]');
    if (!wrap) return;

    var plansWrap = root.querySelector('[data-lp-fp-selling-plans]');
    var config = parseLpFpPurchaseConfig(root);

    function giftOffersPlanMode() {
      if (config.requiresSellingPlan) return 'subscription';
      if (!plansWrap) return 'onetime';
      var checked = plansWrap.querySelector('.lp-Fp_PlanInput:checked');
      if (!checked) return 'onetime';
      return checked.value === 'subscription' ? 'subscription' : 'onetime';
    }

    var mode = giftOffersPlanMode();
    var btn = null;
    var row = root.querySelector('[data-lp-fp-variant-row]');
    if (row) {
      btn = row.querySelector('.lp-Fp_VariantBtn.is-selected') || row.querySelector('.lp-Fp_VariantBtn');
    }
    var kitCount = btn ? parseInt(btn.getAttribute('data-kit-count'), 10) || 0 : 0;

    var unlockedCents = 0;
    wrap.querySelectorAll('[data-lp-fp-gift-slot]').forEach(function (slot) {
      var idx = parseInt(slot.getAttribute('data-slot-index'), 10) || 0;
      var hasGift = slot.getAttribute('data-has-gift') === 'true';
      var locked = slot.querySelector('.lp-Fp_GiftOfferLocked');
      var unlocked = slot.querySelector('.lp-Fp_GiftOfferUnlocked');
      var showUnlocked = mode === 'subscription' && kitCount >= idx && hasGift;
      if (locked) locked.hidden = showUnlocked;
      if (unlocked) unlocked.hidden = !showUnlocked;
      if (showUnlocked) {
        var val = parseInt(slot.getAttribute('data-gift-value-cents'), 10);
        if (!isNaN(val) && val > 0) unlockedCents += val;
      }
    });

    /* The gift wrap and the footer carry the plan mode and tier so CSS can
       swap the locked text on one-time and show flex-only, onetime-only and
       kit-N-only footer lines. */
    wrap.setAttribute('data-plan-mode', mode);
    var footer = wrap.querySelector('[data-lp-fp-gift-footer]');
    if (footer) {
      footer.setAttribute('data-plan-mode', mode);
      footer.setAttribute('data-kit-count', String(kitCount));
    }

    var totalEl = wrap.querySelector('[data-lp-fp-gift-total]');
    if (totalEl) {
      var template = totalEl.getAttribute('data-template') || '';
      if (mode === 'subscription' && unlockedCents > 0 && template.indexOf('{amount}') !== -1) {
        totalEl.textContent = template.replace(/\{amount\}/g, lpFpFormatMoney(unlockedCents));
        totalEl.hidden = false;
      } else {
        totalEl.hidden = true;
        totalEl.textContent = '';
      }
    }
  }

  function getGiftLineItemsForCart(root, mode, kitCount) {
    if (mode !== 'subscription') return [];
    var wrap = root.querySelector('[data-lp-fp-gift-offers]');
    if (!wrap) return [];
    var out = [];
    wrap.querySelectorAll('[data-lp-fp-gift-slot]').forEach(function (slot) {
      var idx = parseInt(slot.getAttribute('data-slot-index'), 10) || 0;
      if (kitCount < idx) return;
      if (slot.getAttribute('data-has-gift') !== 'true') return;
      var vid = slot.getAttribute('data-gift-variant-id');
      if (!vid) return;
      var id = parseInt(vid, 10);
      if (isNaN(id)) return;
      out.push({ id: id, quantity: 1 });
    });
    return out;
  }

  function detectIsNl() {
    var pathLang = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    if (pathLang && pathLang[1] !== 'nl') return false;
    if (window.Shopify && window.Shopify.locale && window.Shopify.locale !== 'nl') return false;
    return true;
  }

  function initPurchase(root) {
    var variantRow = root.querySelector('[data-lp-fp-variant-row]');
    var atcBtn = root.querySelector('[data-lp-fp-atc]');
    if (!variantRow || !atcBtn) return;

    var plansWrap = root.querySelector('[data-lp-fp-selling-plans]');
    var hiddenPlan = plansWrap ? plansWrap.querySelector('.js-lp-fp-selling-plan-input') : null;
    var isNl = detectIsNl();
    var config = parseLpFpPurchaseConfig(root);

    var variantBtns = Array.prototype.slice.call(variantRow.querySelectorAll('.lp-Fp_VariantBtn'));
    var atcLabel = root.querySelector('[data-lp-fp-atc-label]');
    var atcError = root.querySelector('[data-lp-fp-atc-error]');

    function getPlanMode() {
      if (config.requiresSellingPlan) return 'subscription';
      if (!plansWrap) return 'onetime';
      var checked = plansWrap.querySelector('.lp-Fp_PlanInput:checked');
      if (!checked) return 'onetime';
      return checked.value === 'subscription' ? 'subscription' : 'onetime';
    }

    function getSelectedVariantBtn() {
      if (!variantRow) return null;
      var sel = variantRow.querySelector('.lp-Fp_VariantBtn.is-selected');
      return sel || variantBtns[0] || null;
    }

    function syncHiddenSellingPlan(btn) {
      if (!hiddenPlan) return;
      var mode = getPlanMode();
      if (mode === 'subscription' && btn) {
        var pid = btn.getAttribute('data-plan-id') || '';
        hiddenPlan.value = pid;
      } else {
        hiddenPlan.value = '';
      }
    }

    function updateVariantRowPrices() {
      var mode = getPlanMode();
      variantBtns.forEach(function (b) {
        var priceEl = b.querySelector('[data-lp-fp-variant-price]');
        if (!priceEl) return;
        var subDisp = b.getAttribute('data-sub-display') || '';
        var oneDisp = b.getAttribute('data-price-display') || '';
        if (mode === 'subscription' && subDisp) {
          priceEl.textContent = subDisp;
        } else {
          priceEl.textContent = oneDisp;
        }
      });
    }

    function updateVariantOptionTextVisibility() {
      var mode = getPlanMode();
      variantBtns.forEach(function (b) {
        var els = b.querySelectorAll('[data-lp-fp-variant-option-text]');
        els.forEach(function (el) {
          var elMode = el.getAttribute('data-mode');
          if (elMode === mode) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      });
    }

    function updateVariantPerKitLines() {
      var mode = getPlanMode();
      var defaultSuffix = isNl ? '/maand' : '/month';
      var meta = config.kitSuffix != null ? String(config.kitSuffix).trim() : '';
      var once = config.suffixOnetime != null ? String(config.suffixOnetime).trim() : '';
      var raw = '';

      if (mode === 'onetime' && once.toLowerCase() === 'none') {
        // "none" override: hide suffix entirely, beats metafield
        raw = '';
      } else if (meta !== '') {
        raw = isNl ? meta : (/maand/i.test(meta) ? '/month' : meta);
      } else if (mode === 'subscription') {
        raw = (config.suffixSubscription != null && String(config.suffixSubscription).trim()) || defaultSuffix;
      } else {
        raw =
          once ||
          (config.suffixSubscription != null && String(config.suffixSubscription).trim()) ||
          defaultSuffix;
      }
      if (!isNl && /maand/i.test(raw)) raw = '/month';
      var tail = '';
      if (raw) {
        tail = raw.charAt(0) === '/' ? raw : '/' + raw;
      }

      var isMobileKit =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(max-width: 767px)').matches;
      if (isMobileKit && tail) {
        tail = tail.replace(/\/maand$/i, '/mnd').replace(/\/month$/i, '/mo');
      }

      variantBtns.forEach(function (b) {
        var wrap = b.querySelector('[data-lp-fp-variant-per-kit]');
        if (!wrap) return;
        var strongEl = wrap.querySelector('[data-lp-fp-per-kit-amount]');
        var lightEl = wrap.querySelector('[data-lp-fp-per-kit-suffix]');
        if (!strongEl || !lightEl) return;

        var kits = parseInt(b.getAttribute('data-kit-count'), 10) || 0;
        var subRaw = b.getAttribute('data-sub-price') || '';
        var oneRaw = b.getAttribute('data-price') || '';
        var useSub = mode === 'subscription' && subRaw !== '';
        var totalCents = parseInt(useSub ? subRaw : oneRaw, 10);

        if (!kits || isNaN(totalCents) || totalCents <= 0) {
          wrap.setAttribute('hidden', '');
          strongEl.textContent = '';
          lightEl.textContent = '';
          return;
        }

        var perCents = Math.round(totalCents / kits);
        strongEl.textContent = lpFpFormatMoney(perCents);
        lightEl.textContent = tail;
        wrap.removeAttribute('hidden');
      });
    }

    function setAtcLabel(btn) {
      if (!atcLabel || !btn) return;
      var mode = getPlanMode();
      var rawSep = config.separator != null ? config.separator : '|';
      var sep = ' ' + rawSep.trim() + ' ';
      var prefix =
        mode === 'subscription'
          ? config.ctaSubscription || 'Start mijn plan '
          : config.ctaOnetime || 'Start mijn plan ';
      var oneDisp = btn.getAttribute('data-price-display') || '';
      var subDisp = btn.getAttribute('data-sub-display') || '';

      atcLabel.textContent = '';
      atcLabel.appendChild(document.createTextNode(prefix + sep));
      var mainSpan = document.createElement('span');
      mainSpan.className = 'lp-Fp_AtcPrice';
      if (mode === 'subscription' && subDisp) {
        mainSpan.textContent = subDisp;
        atcLabel.appendChild(mainSpan);
        var subRaw = btn.getAttribute('data-sub-price') || '';
        var variantCompareRaw = btn.getAttribute('data-compare-price') || '';
        var subCompareRaw = btn.getAttribute('data-sub-compare-price') || '';
        var oneRaw = btn.getAttribute('data-price') || '';
        var subCents = parseInt(subRaw, 10);
        /* Prefer variant.compare_at_price (the "full bottle × kits" value),
           fall back to selling plan compare_at, then to OTP variant price. */
        var compareCents = parseInt(variantCompareRaw, 10);
        if (isNaN(compareCents)) compareCents = parseInt(subCompareRaw, 10);
        if (isNaN(compareCents)) compareCents = parseInt(oneRaw, 10);
        /* Add unlocked gift values for the selected kit count */
        var kitCount = parseInt(btn.getAttribute('data-kit-count'), 10) || 0;
        var giftCents = getUnlockedGiftValueCents(kitCount);
        var totalPackCents = (isNaN(compareCents) ? 0 : compareCents) + giftCents;
        if (
          !isNaN(subCents) &&
          totalPackCents > subCents
        ) {
          atcLabel.appendChild(document.createTextNode(' '));
          var strikeSpan = document.createElement('span');
          strikeSpan.className = 'lp-Fp_AtcPrice lp-Fp_AtcPrice--strike';
          strikeSpan.textContent = lpFpFormatMoney(totalPackCents);
          atcLabel.appendChild(strikeSpan);
        }
      } else {
        mainSpan.textContent = oneDisp;
        atcLabel.appendChild(mainSpan);
      }
    }

    function getUnlockedGiftValueCents(kitCount) {
      var total = 0;
      var wrap = root.querySelector('[data-lp-fp-gift-offers]');
      if (!wrap) return 0;
      wrap.querySelectorAll('[data-lp-fp-gift-slot]').forEach(function (slot) {
        var idx = parseInt(slot.getAttribute('data-slot-index'), 10) || 0;
        if (idx > kitCount) return;
        if (slot.getAttribute('data-has-gift') !== 'true') return;
        var val = parseInt(slot.getAttribute('data-gift-value-cents'), 10);
        if (!isNaN(val) && val > 0) total += val;
      });
      return total;
    }

    function updateVariantDiscountBadges() {
      var firstBtn = variantBtns[0];
      if (!firstBtn) return;

      var kitsFirst = parseInt(firstBtn.getAttribute('data-kit-count'), 10) || 0;
      var baseTotalOneTimeCents = parseInt(firstBtn.getAttribute('data-price'), 10);
      if (isNaN(baseTotalOneTimeCents) || baseTotalOneTimeCents <= 0 || kitsFirst <= 0) return;

      var perBottleOneTimeCents = baseTotalOneTimeCents / kitsFirst;
      var planMode = getPlanMode();

      var rawDiscountTemplate =
        (config.discountBadgeTemplate && String(config.discountBadgeTemplate).trim()) || 'Bespaar {amount}';
      var template =
        rawDiscountTemplate.indexOf('{amount}') !== -1 ? rawDiscountTemplate : 'Bespaar {amount}';

      variantBtns.forEach(function (b) {
        var el = b.querySelector('[data-lp-fp-discount-badge]');
        if (!el) return;

        var kits = parseInt(b.getAttribute('data-kit-count'), 10) || 0;
        if (kits < 1) return;

        var subRaw = b.getAttribute('data-sub-price') || '';
        var oneRaw = b.getAttribute('data-price') || '';
        var useSub = planMode === 'subscription' && subRaw !== '';
        var priceCents = parseInt(useSub ? subRaw : oneRaw, 10);
        if (isNaN(priceCents) || priceCents <= 0) {
          el.setAttribute('hidden', '');
          el.textContent = '';
          return;
        }

        var expectedAtFirstVariantOneTimeRate = Math.round(perBottleOneTimeCents * kits);
        if (expectedAtFirstVariantOneTimeRate <= 0) return;

        var saveCents = expectedAtFirstVariantOneTimeRate - priceCents;
        var saveCentsDisplay = Math.round(saveCents / 100) * 100;
        if (saveCentsDisplay <= 0) {
          el.setAttribute('hidden', '');
          el.textContent = '';
          return;
        }

        var amountStr = lpFpFormatMoney(saveCentsDisplay);
        var pct = Math.min(
          100,
          Math.round((saveCents / expectedAtFirstVariantOneTimeRate) * 100)
        );
        el.textContent = template
          .replace(/\{amount\}/g, amountStr)
          .replace(/\{pct\}/g, String(pct));
        el.removeAttribute('hidden');
      });
    }

    function fullSync() {
      var btn = getSelectedVariantBtn();
      syncHiddenSellingPlan(btn);
      updateVariantRowPrices();
      updateVariantOptionTextVisibility();
      updateVariantPerKitLines();
      updateVariantDiscountBadges();
      setAtcLabel(btn);
      syncGiftOffers(root);
      if (typeof updateDuoPrice === 'function') updateDuoPrice();
      if (atcBtn && btn) {
        var mode = getPlanMode();
        var planId = btn.getAttribute('data-plan-id') || '';
        var needPlan = mode === 'subscription';
        var missingPlan = needPlan && !planId;
        var unavailable = btn.getAttribute('data-available') === 'false';
        atcBtn.disabled = unavailable || missingPlan;
        if (atcError) {
          if (missingPlan && !unavailable) {
            atcError.textContent = 'Abonnementsprijs niet beschikbaar voor deze variant.';
            atcError.hidden = false;
          } else {
            atcError.hidden = true;
            atcError.textContent = '';
          }
        }
      }
    }

    var duoInput = root.querySelector('[data-lp-fp-duo-input]');
    var duoPriceEl = root.querySelector('[data-lp-fp-duo-price]');

    function isDuoBtn(b) {
      return !!(b && b.getAttribute('data-duo-for'));
    }

    function duoPartnerOf(btn) {
      if (!btn || !variantRow) return null;
      var id = btn.getAttribute('data-variant-id') || '';
      return variantRow.querySelector('.lp-Fp_VariantBtn--duo[data-duo-for="' + id + '"]');
    }

    function tierPartnerOf(duoBtn) {
      if (!duoBtn || !variantRow) return null;
      var tierId = duoBtn.getAttribute('data-duo-for') || '';
      return variantRow.querySelector('.lp-Fp_VariantBtn[data-variant-id="' + tierId + '"]:not(.lp-Fp_VariantBtn--duo)');
    }

    function selectBtn(b) {
      if (!b || b.disabled) return;
      variantBtns.forEach(function (x) {
        x.classList.remove('is-selected');
      });
      b.classList.add('is-selected');
    }

    function updateDuoPrice() {
      if (!duoPriceEl) return;
      var sel = getSelectedVariantBtn();
      if (!sel) return;
      var tierBtn = isDuoBtn(sel) ? tierPartnerOf(sel) : sel;
      var duoBtn = isDuoBtn(sel) ? sel : duoPartnerOf(sel);
      if (!tierBtn || !duoBtn) {
        duoPriceEl.textContent = '';
        return;
      }
      var mode = getPlanMode();
      var attr = mode === 'subscription' ? 'data-sub-price' : 'data-price';
      var tierCents = parseInt(tierBtn.getAttribute(attr) || tierBtn.getAttribute('data-price'), 10) || 0;
      var duoCents = parseInt(duoBtn.getAttribute(attr) || duoBtn.getAttribute('data-price'), 10) || 0;
      var diff = duoCents - tierCents;
      if (diff <= 0) {
        duoPriceEl.textContent = '';
        return;
      }
      var tpl = duoPriceEl.getAttribute('data-template') || '+ {amount}';
      duoPriceEl.textContent = tpl.replace('{amount}', lpFpFormatMoney(diff));
    }

    function applyDuoState() {
      if (!duoInput) return;
      var sel = getSelectedVariantBtn();
      if (!sel) return;
      if (duoInput.checked) {
        if (!isDuoBtn(sel)) {
          var duoBtn = duoPartnerOf(sel);
          if (duoBtn && !duoBtn.disabled) selectBtn(duoBtn);
        }
      } else if (isDuoBtn(sel)) {
        var tierBtn = tierPartnerOf(sel);
        if (tierBtn) selectBtn(tierBtn);
      }
    }

    variantBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        selectBtn(b);
        if (duoInput && duoInput.checked && !isDuoBtn(b)) {
          var duoBtn = duoPartnerOf(b);
          if (duoBtn && !duoBtn.disabled) selectBtn(duoBtn);
        }
        fullSync();
      });
    });

    if (duoInput) {
      duoInput.addEventListener('change', function () {
        applyDuoState();
        fullSync();
      });
    }

    if (plansWrap) {
      plansWrap.addEventListener('change', function (e) {
        if (e.target.classList.contains('lp-Fp_PlanInput')) fullSync();
      });
    }

    applyDuoState();
    fullSync();
    updateDuoPrice();

    var kitMql = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 767px)') : null;
    function onKitViewportChange() {
      updateVariantPerKitLines();
    }
    if (kitMql) {
      if (kitMql.addEventListener) {
        kitMql.addEventListener('change', onKitViewportChange);
      } else if (kitMql.addListener) {
        kitMql.addListener(onKitViewportChange);
      }
    }

    atcBtn.addEventListener('click', function () {
      var btn = getSelectedVariantBtn();
      if (!btn || atcBtn.disabled || btn.getAttribute('data-available') === 'false') return;

      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;

      var mode = getPlanMode();
      var item = { id: Number(vid), quantity: 1 };
      if (mode === 'subscription') {
        var spid = btn.getAttribute('data-plan-id');
        if (spid) item.selling_plan = Number(spid);
      }

      var kitCount = parseInt(btn.getAttribute('data-kit-count'), 10) || 0;
      var giftLineItems = getGiftLineItemsForCart(root, mode, kitCount);
      var cartItems = [item].concat(giftLineItems);
      var codesJoined = normalizeDiscountCodesForCart(getGiftDiscountCodesRaw(root));
      var funnelAttrs = buildFunnelAttributes(readFunnelContext(root), btn, mode, giftLineItems.length);

      atcBtn.disabled = true;
      if (atcError) {
        atcError.hidden = true;
        atcError.textContent = '';
      }

      clearCart()
        .then(function () {
          return addItemsToCart(cartItems);
        })
        .then(function () {
          if (!codesJoined || giftLineItems.length === 0) return true;
          var giftIds = giftLineItems.map(function (g) {
            return g.id;
          });
          // Try the cart-level discount, then check the cart rather than the
          // response. If the gifts are still not free, let Shopify apply the
          // codes itself via /discount/<code> and check again.
          return applyCartDiscountCodes(codesJoined)
            .then(function (updatedCart) {
              return giftLinesAreFree(giftIds, updatedCart);
            })
            .then(function (free) {
              if (free) return true;
              return applyDiscountsViaRoute(codesJoined).then(function () {
                return giftLinesAreFree(giftIds);
              });
            });
        })
        .then(function (giftsAreFree) {
          // Stamp the funnel onto the cart so the resulting order records which
          // lander produced it. A stamping failure must never block the purchase,
          // so this branch always resolves and passes the gift verdict through.
          return applyCartAttributes(funnelAttrs)
            .then(function () {
              stampKlaviyo(funnelAttrs);
              return giftsAreFree;
            })
            .catch(function () {
              return giftsAreFree;
            });
        })
        .then(function (giftsAreFree) {
          if (giftsAreFree === false) {
            // Both routes failed. Continuing would charge the shopper for gifts
            // this page promised were free, so stop instead. A lost sale is
            // recoverable; billing someone for a free gift is not.
            throw new Error('GIFT_DISCOUNT_FAILED');
          }
          window.location.href = checkoutHref();
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          if (window.console && window.console.error) {
            window.console.error('[lp-fp] add to cart failed', err);
          }
          if (atcError) {
            atcError.textContent =
              err && err.message === 'GIFT_DISCOUNT_FAILED'
                ? 'We konden je gratis cadeaus niet toevoegen. Probeer het opnieuw, of mail support@guudwoman.com.'
                : 'Er ging iets mis. Probeer het opnieuw, of mail support@guudwoman.com.';
            atcError.hidden = false;
          }
        });
    });
  }

  function initFeatureProduct(root) {
    var mainEl = root.querySelector('.js-lp-fp-main');
    var thumbEl = root.querySelector('.js-lp-fp-thumbs');
    var pagEl = root.querySelector('.js-lp-fp-pagination');
    var mainPrev = root.querySelector('.js-lp-fp-main-prev');
    var mainNext = root.querySelector('.js-lp-fp-main-next');

    if (mainEl && typeof Swiper !== 'undefined') {
      destroySwiper(mainEl);
      destroySwiper(thumbEl);

      var thumbSwiper = null;
      if (thumbEl) {
        thumbSwiper = new Swiper(thumbEl, {
          slidesPerView: 'auto',
          spaceBetween: 14,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
      }

      var mainOpts = {
        spaceBetween: 12,
        speed: 350,
        watchOverflow: true,
        slidesPerView: 1.05,
        pagination: {
          el: pagEl,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
              enabled: false,
            },
          },
        },
      };

      if (mainPrev && mainNext) {
        mainOpts.navigation = {
          prevEl: mainPrev,
          nextEl: mainNext,
        };
      }

      if (thumbSwiper) {
        mainOpts.thumbs = { swiper: thumbSwiper };
      }

      new Swiper(mainEl, mainOpts);
    }

    initSellingPlans(root);
    initPurchase(root);
    if (!root.querySelector('[data-lp-fp-variant-row]') || !root.querySelector('[data-lp-fp-atc]')) {
      syncGiftOffers(root);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lp-fp-root]').forEach(initFeatureProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resyncSellingPlansAfterRestore();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('[data-lp-fp-root]');
    if (root) initFeatureProduct(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('[data-lp-fp-root]');
    if (!root) return;
    destroySwiper(root.querySelector('.js-lp-fp-main'));
    destroySwiper(root.querySelector('.js-lp-fp-thumbs'));
  });
})();

document.querySelectorAll('.lp-Fp_GiftOfferGratisBadge').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var dataId = btn.getAttribute('data-id');
    var overlay = document.querySelector('[aria-labelledby="' + dataId + '"]');
    if (!overlay) return;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('modal-open');
  });
});

document.querySelectorAll('.mp-close').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var overlay = btn.closest('.mp-overlay');
    overlay.hidden = true;
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
  });
});

document.querySelectorAll('.mp-overlay').forEach(function (overlay) {
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      overlay.hidden = true;
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    }
  });
});

(function () {
  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6; // Sunday or Saturday
  }

  function computeDelivery(el) {
    var template = el.dataset.template || '';
    if (template.indexOf('{date}') === -1) return;

    var locale = el.dataset.locale || 'en';
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    var cutoffMinute = parseInt(el.dataset.cutoffMinute, 10);
    if (isNaN(cutoffHour)) cutoffHour = 12;
    if (isNaN(cutoffMinute)) cutoffMinute = 0;
    var workingDays = parseInt(el.dataset.workingDays, 10) || 1;

    var now = new Date();
    var shipDate = new Date(now);

    // Past cutoff: ship next day instead of today
    var pastCutoff =
      now.getHours() > cutoffHour ||
      (now.getHours() === cutoffHour && now.getMinutes() >= cutoffMinute);
    if (pastCutoff) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // No weekend shipping: push forward to next weekday
    while (isWeekend(shipDate)) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Add working days (Mon–Fri only)
    var delivery = new Date(shipDate);
    var added = 0;
    while (added < workingDays) {
      delivery.setDate(delivery.getDate() + 1);
      if (!isWeekend(delivery)) added++;
    }

    var formatted = new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(delivery);

    el.textContent = template.replace('{date}', formatted);
  }

  function init() {
    document.querySelectorAll('[data-delivery-predictor]').forEach(computeDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/*
  Recognition blocks per quiz answer.

  Octane result pages carry copy written for one answer combination. A single
  destination page would lose that, so the page holds several recognition blocks
  and shows the one whose segment key matches the URL parameter the quiz appends
  (?r=pil). The blank-key block is the fallback and is the only one rendered
  visible server side, so direct traffic and a JS failure both still read fine.
*/
(function () {
  function normalise(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function readSegment(paramName) {
    try {
      var params = new URLSearchParams(window.location.search);
      return normalise(params.get(paramName));
    } catch (e) {
      return '';
    }
  }

  function applySegment(root) {
    var blocks = root.querySelectorAll('[data-lp-segment]');
    if (!blocks.length) return;

    var paramName = root.getAttribute('data-lp-segment-param') || 'r';
    var segment = readSegment(paramName);
    var matched = false;

    if (segment) {
      blocks.forEach(function (block) {
        if (normalise(block.getAttribute('data-lp-segment')) === segment) {
          matched = true;
        }
      });
    }

    blocks.forEach(function (block) {
      var key = normalise(block.getAttribute('data-lp-segment'));
      var show = matched ? key === segment : key === '';
      block.hidden = !show;
      block.classList.toggle('is-segment-hidden', !show);
    });
  }

  function init() {
    document.querySelectorAll('[data-lp-fp-root]').forEach(applySegment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

